import { apiUrl as channelApiUrl } from '@symbo.ls/channels'

export function generatePreviewUrl() {
  const isCavnas = this.call('isCanvas')
  const selected = isCavnas && this.getSelected()
  const key = isCavnas && this.getSelectedKey()
  const appKey = this.getAppKey()

  let url = appKey
  const isPage = key?.startsWith('/')
  if (key) {
    url += isPage ? key : `/component?key=${key}`
  }

  if (selected?.state?.content?.src) {
    return selected.state.content.src.replace('https://', '')
  }

  const version = this.getActiveVersion()
  const latestVersion = this.getLatestVersion()
  const isOld = version && version !== latestVersion
  if (isOld) {
    url += `${url.includes('?') ? '&' : '?'}version=${version}`
  }

  if (this.call('isProduction')) return `https://${url}`

  // Render via the per-channel API. channelApiUrl() reads the active
  // channel from SYMBOLS_API_CHANNEL / SYMBOLS_APP_ENV / NODE_ENV, so
  // the local dev shell hits next.api.symbols.app (or whatever channel
  // is active) without hardcoding URLs.
  const env = this.getRootState('ENV')
  return `${channelApiUrl(env)}/?renderUrl=${url}`
}

export function generateUrl() {
  const selected = this.getSelected()
  const appKey = this.getAppKey()
  if (!selected) {
    return `${appKey.split('.')[0]}`
  }
  const key = this.getSelectedKey()
  const isPage = key.startsWith('/')
  const path = isPage ? key : `/${key}`
  return `symbo.ls/${appKey.split('.')[0]}${path || ''}`
}

export function openInNewTab() {
  const openUrl = this.call('generatePreviewUrl')
  const url = window.open(openUrl, 'Symbols preview')

  // Setup interval to check when the window is closed
  this.syncCanvas({ openUrl })

  const checkInterval = setInterval(() => {
    if (url && url.closed) {
      this.syncCanvas({ openUrl: null })
      clearInterval(checkInterval)
    }
  }, 1500)
}
